import './App.css'
import { useEffect, useState, Suspense, lazy } from 'react'
import Cookies from "js-cookie"
import Sidebar from './layouts/Sidebar/Sidebar'
import { Route, Routes, useLocation } from 'react-router-dom'
import { AnimatePresence } from 'framer-motion'
import AppContext from './context'

// Services
import { AuthService } from './services/auth'

// Layouts
import { Alert } from './layouts/Alert/Alert'
import { AlertEntity } from './layouts/Alert/AlertEntity'
import { UserContextEntity } from './entities/UserEntity'
import ReportSerial from './features/Report/ReportSerial'
const ChangePass = lazy(() => import('./layouts/ChangePass/ChangePass'))
const Login = lazy(() => import('./layouts/Login/Login'))

// Features
const Welcome = lazy(() => import('./features/Welcome/Welcome'))
const NotFound = lazy(() => import('./features/NotFound/NotFound'))
const MasterUser = lazy(() => import('./features/Master/MasterUser'))


const GenerateSerial = lazy(() => import('./features/GenerateSerial/GenerateSerial'))

function App() {
    const location = useLocation()

    // States
    const [stateShowSidebar, setStateShowSidebar] = useState<boolean>(false)
    const [stateShowLogin, setStateShowLogin] = useState<boolean>(true)
    const [stateShowChangePass, setStateShowChangePass] = useState<boolean>(false)
    const [stateShowLoading, setStateShowLoading] = useState<boolean>(false)

    const [stateShowAlert, setStateShowAlert] = useState<boolean>(false)
    const [alertEntity, setAlertEntity] = useState<AlertEntity | null>(null)

    const [version, setVersion] = useState<{ ui: string, server: string }>({ ui: "v1.0", server: "v1.0" })

    // Context Entities
    const contextAccessToken: string = Cookies.get('token') ?? ''
    const [contextUserEntity, setContextUserEntity] = useState<UserContextEntity | null>(null)

    // Context Functions
    const contextShowAlertFunc = (val: AlertEntity) => { setStateShowAlert(true); setAlertEntity(val); }
    const contextShowLoadingFunc = (val: boolean) => { setStateShowLoading(val); }
    const contextMakeHeaderFunc = (val: string) => { return val.replace(/ID/g, "Id").replace(/[_-]|(?<=[a-z])(?=[A-Z])/g, " ").toUpperCase(); }

    // REFRESH USER DATA IF COOKIES STILL EXIST
    useEffect(() => {
        console.log('Try refresh...')
        const refresh = async () => {
            try {
                const refreshUser = await AuthService.refreshLogin()

                setContextUserEntity(refreshUser)
                setStateShowLogin(false)
            } catch (error) {
                setContextUserEntity(null)
            }
        }

        refresh()
    }, [])

    return (
        <AppContext.Provider
            value={{
                stateShowLoading,
                contextAccessToken,
                contextUserEntity,
                contextShowAlertFunc,
                contextShowLoadingFunc,
                contextMakeHeaderFunc,
            }}>
            <div className="App-new">
                <Sidebar
                    showSidebar={stateShowSidebar}
                    setShowSidebar={setStateShowSidebar}
                    userEntity={contextUserEntity}
                    setUserEntity={setContextUserEntity}
                    setShowLogin={setStateShowLogin}
                    setShowChangePass={setStateShowChangePass}
                    version={version}
                />

                <main className="main-content" onClick={() => setStateShowSidebar(false)}>
                    <div className="loading" style={{ display: stateShowLoading ? "grid" : "none" }} />
                    <AnimatePresence>
                        <Suspense fallback={<div ></div>}>
                            <Routes location={location} key={location.pathname}>
                                <Route path="/" element={<Welcome loggedIn={contextUserEntity != null ? true : false} />} />
                                <Route path="/serial" element={contextUserEntity != null ? <GenerateSerial /> : <Welcome loggedIn={false} />} />
                                <Route path="/master/users" element={contextUserEntity != null ? <MasterUser /> : <Welcome loggedIn={false} />} />
                                <Route path="/report/serial" element={contextUserEntity != null ? <ReportSerial /> : <Welcome loggedIn={false} />} />

                                <Route path="*" element={<NotFound loggedIn={contextUserEntity != null ? true : false} />} />
                            </Routes>
                        </Suspense>
                    </AnimatePresence>
                </main>

                <Login
                    showLogin={stateShowLogin}
                    setShowLogin={setStateShowLogin}
                    setUserEntity={setContextUserEntity}
                />
                <ChangePass
                    showChangePass={stateShowChangePass}
                    setShowChangePass={setStateShowChangePass}
                />
                <Alert
                    showAlert={stateShowAlert}
                    setShowAlert={setStateShowAlert}
                    alertEntity={alertEntity}
                />
            </div>
        </AppContext.Provider>
    )
}

export default App
